import axios from 'axios';
import config from '../utils/config';

const API_BASE = config.API_BASE_URL;

// Quick debug logs to help diagnose network issues
// Remove or disable in production
try {
	// eslint-disable-next-line no-console
	console.log('API base URL:', API_BASE);
} catch (e) { }

const api = axios.create({
	baseURL: API_BASE,
	// headers: { 'Content-Type': 'application/json' }, // Removed to allow axios to handle Content-Type (e.g. for FormData)
});

// Attach token if present
api.interceptors.request.use((config) => {
	try {
		const token = localStorage.getItem('token');
		// eslint-disable-next-line no-console
		console.log('API request:', config.method, config.url, token ? 'token-present' : 'no-token');
		if (token) config.headers.Authorization = `Bearer ${token}`;
	} catch (e) { }
	return config;
});

// Log responses and errors for easier debugging
api.interceptors.response.use(
	(response) => {
		try { /* eslint-disable-next-line no-console */ console.log('API response:', response.config?.url, response.status); } catch (e) { }
		return response;
	},
	(error) => {
		try {
			// eslint-disable-next-line no-console
			console.error('API error:', error?.config?.url, error?.response?.status, error?.message);
		} catch (e) { }
		return Promise.reject(error);
	}
);

export const productAPI = {
	getAllUsers: () => api.get('/users/products'),
	getActive: () => api.get('/product/active'),
	// Admin
	create: (formData) => api.post('/admin/products', formData),
	update: (id, formData) => api.put(`/admin/products/${id}`, formData),
	getAllAdmin: () => api.get('/admin/products'),
	delete: (id) => api.delete(`/admin/products/${id}`),
};

export const authAPI = {
	register: (data) => api.post('/auth/register', data),
	login: (data) => api.post('/auth/login', data),
};

export const addressAPI = {
	create: (data) => api.post('/address-master/create', data),
	getAll: () => api.get('/address-master/get-all'),
	delete: (id) => api.delete(`/address-master/delete/${id}`), // Added delete method
};

export const orderAPI = {
	placeOrder: (data) => api.post('/users/orders', data),
	getUserOrders: () => api.get('/users/orders'),
	getById: (id) => api.get(`/orders/${id}`),
	cancelOrder: (id) => api.put(`/users/orders/${id}/cancel`),
	updateAddress: (id, addressId) => api.put(`/users/orders/${id}/address`, { address_id: addressId }),
	// Admin functions
	getAllOrders: (config) => api.get('/admin/orders', config),
	updateOrderStatus: (id, data) => api.put(`/admin/orders/${id}/status`, data),
};

export const categoryAPI = {
	getAllAdmin: (config) => api.get('/admin/categories', config),
	create: (data) => api.post('/admin/categories', data),
	update: (id, data) => api.put(`/admin/categories/${id}`, data),
	updateStatus: (id, status) => api.patch(`/categorie/${id}`, { status }),
	getActive: () => api.get('/categories/active'),
};

export const dashboardAPI = {
	getStats: () => api.get('/admin/total-revenue'),
	getProductStats: () => api.get('/admin/total-products'),
	getSalesData: () => api.get('/admin/sales'),
	getTopProducts: () => api.get('/admin/top-products'),
};

export const feedbackAPI = {
	getAll: (config) => api.get('/feedback', config),
	create: (data) => api.post('/feedback', data),
	getById: (product_id) => api.get(`/feedback/${product_id}`),
	update: (id, data) => api.put(`/feedback/${id}`, data),
};

export const stockAPI = {
	getAll: (config) => api.get('/admin/stock', config),
	create: (data) => api.post('/admin/stock', data),
	getLog: () => api.get('/admin/stock/log'),
	getById: (id) => api.get(`/admin/stock/${id}`),
	update: (id, data) => api.put(`/admin/stock/${id}`, data),
	delete: (id) => api.delete(`/admin/stock/${id}`),
};

export const userAPI = {
	adminGetAll: (config) => api.get('/user/admin/users', config),
	adminUpdate: (id, data) => api.put(`/user/admin/users/${id}`, data),
	getProfile: () => api.get('/user/profile'),
	updateProfile: (data) => api.put('/user/users', data),
};


export const wishlistAPI = {
	getAll: () => api.get('/wishlist'),
	add: (data) => api.post('/wishlist/add', data),
	remove: (product_variation_id) => api.delete(`/wishlist/remove/${product_variation_id}`),
};

export const blogAPI = {
	getAll: () => api.get('/blogs'),
	getById: (id) => api.get(`/blogs/${id}`),
	create: (data) => api.post('/blogs', data),
	update: (id, data) => api.put(`/blogs/${id}`, data),
	delete: (id) => api.delete(`/blogs/${id}`),
};

export const contactAPI = {
	create: (data) => api.post('/contact', data),
	getAll: () => api.get('/contact'),
	delete: (id) => api.delete(`/contact/${id}`),
};

export const visitorAPI = {
	trackVisit: () => api.post('/visitors/track'),
	getStats: () => api.get('/admin/visitors/stats'),
};

export default api;

